import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { AppConfigService } from "src/app/configs/app-config.service";

@Pipe({
	name: "appData",
})
@Injectable({
	providedIn: "root",
})
export class AppDataPipe implements PipeTransform {
	brand?: string;

	constructor(private config: AppConfigService) {}

	transform(appName: string): string {
		const brand = this.config.get("brand");

		if (brand === "whatsparts") return "WhatsParts";
		if (brand === "whatsauto") return "WhatsAuto";

		return brand || appName;
	}
}
